//@flow
import * as React from 'react';
import { Button, Box } from '@locus-taxy/neo-ui';
import { SizeEnum } from 'common/enums/UIEnums';
import theme from './EffectiveStatusDropdown.scss';
import classnames from 'classnames';
import { type ThemeType } from 'react-css-themr';
import { type ContractStatusEnum } from 'common/models/flow/MasterContract';

type Props = {
    selectProps: {
        buttonValue: ContractStatusEnum,
        buttonLabel: string,
        isLoading: boolean
    },
    children: React.Node,
    isDisabled: boolean,
    innerRef: React.ElementRef<any>,
    innerProps: $FixMe,
    theme: ThemeType
};

const buttonColorMapping = {
    DRAFT: theme.draft,
    READY: theme.ready,
    VERIFY: theme.verify,
    ACTIVE: theme.active,
    INACTIVE: theme.inactive,
    VOID: theme.void,
    EXPIRED: theme.expired
};
const EffectiveStatusButton = (props: Props) => {
    const {
        selectProps,
        children,
        isDisabled,
        innerRef,
        innerProps,
        theme
    } = props;
    const { buttonLabel, buttonValue, isLoading } = selectProps;
    const statusBasedTheme = buttonColorMapping[buttonValue];
    return (
        <Box {...innerProps} ref={innerRef}>
            <Button
                semibold
                uppercase
                disabled={isDisabled}
                smallLoader
                enableTooltipOnHover
                //@TODO: Remove classname usage as part of ES-25554
                className={classnames(theme.button, statusBasedTheme)}
                size={SizeEnum.Small}
                isLoading={isLoading}
            >
                {buttonLabel}
            </Button>
            {children}
        </Box>
    );
};

export default EffectiveStatusButton;
